import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { DoctorsService } from '../../../../services/doctors';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-alljobs',
  templateUrl: './alljobs.component.html',
  styleUrl: './alljobs.component.scss'
})
export class AlljobsComponent implements OnInit {
  @Input() isProfile: string = '';

  allData: any[] = [];

  userimage!: string;
  userData!: users;
  username!: string;
  userPhone: string = '';
  userName: string = '';
  profile!: boolean;
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';

  private readonly desktopColumns: string[] = [
    'doctor_image',
    'name',
    'mobile',
    'specialty',
    'university',
    'graduation_year',
    'qualification',
    'has_master',
    'has_phd',
    'files',
    'fellowship',
    'classification_status',
    'ksa_experience',
    'residence_place',
    'birth_place',
    'birth_date',
    'visa',
    'transfer_of_sponsorship',
    'call',
    'chat',
    'options'
  ];

  private readonly desktopColumnsWithAudit: string[] = [
    'doctor_image',
    'name',
    'mobile',
    'specialty',
    'university',
    'graduation_year',
    'qualification',
    'has_master',
    'has_phd',
    'files',
    'fellowship',
    'classification_status',
    'ksa_experience',
    'residence_place',
    'birth_place',
    'birth_date',
    'has_dataflow',
    'offer',
    'visa',
    'transfer_of_sponsorship',
    'add_by',
    'editor',
    'call',
    'chat',
    'options'
  ];

  private readonly mobileColumns: string[] = [
    'doctor_image',
    'name',
    'specialty',
    'mobile',
    'birth_date',
    'files',
    'options'
  ];

  displayedColumns: string[] = [...this.desktopColumns];

  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = '';
  orderId!: any;
  statuslist: any;
  clear: boolean = false;

  accountType!: string;
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;

  stockTotal: any;
  totalItems: number = 0;

  searched: boolean = false;
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem('language') === 'ar';
  isMobile: boolean = false;

  pageSize: number = 10;
  currentPage: number = 1;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  private readonly backendStorageBaseUrl =
    'https://backendtest.blueboxpet.com/storage/app/public';

  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => data?.['user_type'] === '1')
  );

  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => data?.['user_type'] === '6')
  );

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private deviceService: DeviceDetectorService,
    private _doctor: DoctorsService,
    private excelExportService: ExcelExportService,
    private _userService: UserService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();

    this._userService.getAccountType().subscribe({
      next: data => {
        this.accountType = data?.['user_type'];
        this.isAdmin = this.accountType === '1';
        this.isSubAdmin = this.accountType === '6';

        const hasPhoneAccess = Boolean(data?.['has_access_to_phone_numbers']);

        this.buildDisplayedColumns(hasPhoneAccess);
        this.getAllClients(this.pageSize, 1, false);
      },
      error: error => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  search(): void {
    const key = this.searchKey?.trim();

    if (!key) {
      this.getAllClients(this.pageSize, 1, false);
      return;
    }

    this.contentReady = true;
    this.searched = true;

    this._doctor.search(key, false).subscribe({
      next: (res: any) => {
        const list = Array.isArray(res) ? res : res?.data || [];

        this.allData = list;
        this.totalItems = res?.total || list.length;

        this.dataSource = new MatTableDataSource(this.allData);

        this.contentReady = false;
        this.noData = this.allData.length === 0;
      },
      error: error => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  getAllClients(perpage: any, page: any, isdoctor: any): void {
    this.contentReady = true;
    this.searched = false;

    this.pageSize = Number(perpage) || 10;
    this.currentPage = Number(page) || 1;

    this._doctor.getAll(this.pageSize, this.currentPage, isdoctor).subscribe({
      next: (data: any) => {
        this.allData = data?.data || [];
        this.stockTotal = data?.last_page || 0;
        this.totalItems = data?.total || this.allData.length;

        this.dataSource = new MatTableDataSource(this.allData);

        this.contentReady = false;
        this.noData = this.allData.length === 0;
      },
      error: error => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  onPaginateChange(event: PageEvent): void {
    const newPage = event.pageIndex + 1;
    const newPageSize = event.pageSize || this.pageSize;

    this.getAllClients(newPageSize, newPage, false);
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.dataSource.filter = filterValue;
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', '_doctor', ['actions']);
  }

  delete(id: any): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'نعم' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then(result => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._doctor.delete(id).subscribe({
          next: () => {
            this.getAllClients(this.pageSize, this.currentPage, false);
          },
          error: err => {
            console.error(err);
            this.contentReady = false;
          }
        });
      }
    });
  }

  edit(itemobj: any): void {
    this.router.navigate(['/createjob'], { queryParams: itemobj });
  }

  call(phone: any): void {
    if (!phone) return;

    window.open('tel:+' + phone, '_blank');
  }

  chat(phone: any): void {
    if (!phone) return;

    window.open('https://api.whatsapp.com/send?phone=2' + phone, '_blank');
  }

  formatDate(date: string): string {
    if (!date) return '-';

    const d = new Date(date);

    if (Number.isNaN(d.getTime())) {
      return '-';
    }

    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);

    return `${day}-${month}-${year}`;
  }

  formatFullDate(date: string): string {
    if (!date) return '-';

    const value = String(date).split('T')[0];
    const parts = value.split('-');

    if (parts.length !== 3) return '-';

    const [year, month, day] = parts;

    return `${day}-${month}-${year}`;
  }

  isTruthy(value: any): boolean {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  isFalsy(value: any): boolean {
    return value === false || value === 0 || value === '0' || value === 'false';
  }

  getDoctorImage(item: any): string {
    const raw =
      item?.image_url ||
      item?.doctor_image_url ||
      item?.doctor_image ||
      item?.image ||
      item?.profile_image ||
      item?.photo;

    return this.fixStorageUrl(raw);
  }

  getCertificates(item: any): any[] {
    const raw =
      item?.certificates ||
      item?.doctor_certificates ||
      item?.certificate_files ||
      item?.files ||
      [];

    if (Array.isArray(raw)) {
      return raw.filter(cert => this.getCertificateUrl(cert));
    }

    if (typeof raw === 'string') {
      const value = raw.trim();

      if (!value || value === 'null' || value === '[]') {
        return [];
      }

      try {
        const parsed = JSON.parse(value);

        if (Array.isArray(parsed)) {
          return parsed.filter(cert => this.getCertificateUrl(cert));
        }
      } catch {
        return value
          .split(',')
          .map(item => item.trim())
          .filter(Boolean);
      }

      return [value];
    }

    return [];
  }

  getCertificateUrl(cert: any): string {
    const raw =
      cert?.file_path ||
      cert?.url ||
      cert?.file_url ||
      cert?.path ||
      cert?.file ||
      cert?.certificate ||
      cert;

    return this.fixStorageUrl(raw);
  }

  getFileLabel(cert: any, index: number): string {
    if (cert?.original_name) {
      return cert.original_name;
    }

    if (cert?.type) {
      return String(cert.type).toUpperCase();
    }

    if (cert?.mime_type === 'application/pdf') {
      return `PDF ${index + 1}`;
    }

    return `ملف ${index + 1}`;
  }

  private buildDisplayedColumns(hasPhoneAccess: boolean): void {
    let columns = this.isMobile
      ? [...this.mobileColumns]
      : hasPhoneAccess
        ? [...this.desktopColumnsWithAudit]
        : [...this.desktopColumns];

    if (!hasPhoneAccess) {
      const colsToRemove = ['mobile', 'call', 'chat'];
      columns = columns.filter(col => !colsToRemove.includes(col));
    }

    this.displayedColumns = columns;
  }

  fixStorageUrl(url: any): string {
    if (!url) return '';

    let path = String(url).trim();

    if (!path || path === 'null' || path === 'undefined') return '';

    const isFullExternalUrl =
      /^https?:\/\//i.test(path) &&
      !/^https?:\/\/backendtest\.blueboxpet\.com\//i.test(path);

    if (isFullExternalUrl) {
      return path;
    }

    path = path.replace(/^https?:\/\/backendtest\.blueboxpet\.com\//i, '');
    path = path.replace(/^\/+/, '');

    path = path
      .replace(/^storage\/app\/public\//, '')
      .replace(/^storage\/app\//, '')
      .replace(/^storage\/public\//, '')
      .replace(/^storage\//, '')
      .replace(/^app\/public\//, '')
      .replace(/^public\//, '');

    return `${this.backendStorageBaseUrl}/${path}`;
  }
}